export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const FORMULA_LIST_SUCCESS = 'FORMULA_LIST_SUCCESS';
export const FORMULA_DELETE_SUCCESS = 'FORMULA_DELETE_SUCCESS';
export const FORMULA_CREATE_SUCCESS = 'FORMULA_CREATE_SUCCESS';
export const FORMULA_UPDATE_SUCCESS = 'FORMULA_UPDATE_SUCCESS';
export const FORMULA_BY_ID_SUCCESS = 'FORMULA_BY_ID_SUCCESS';
export const FORMULA_VALIDATE_SUCCESS = 'FORMULA_VALIDATE_SUCCESS';
export const FORMULA_FUNCTIONS_SUCCESS = 'FORMULA_FUNCTIONS_SUCCESS';
export const FORMULA_CATEGORIES_SUCCESS = 'FORMULA_CATEGORIES_SUCCESS';
export const FORMULA_BY_NAME_SUCCESS = 'FORMULA_BY_NAME_SUCCESS';
export const FORMULA_VERSIONS_SUCCESS = 'FORMULA_VERSIONS_SUCCESS';
export const FORMULA_VERSION_SUCCESS = 'FORMULA_VERSION_SUCCESS';
export const FORMULA_EXECUTE_SUCCESS = 'FORMULA_EXECUTE_SUCCESS';
export const FORMULA_EXECUTE_VERSION_SUCCESS = 'FORMULA_EXECUTE_VERSION_SUCCESS';
/* FILTERS */
export const FILTER_LIST_SUCCESS = 'FILTER_LIST_SUCCESS';
export const FILTER_GET_SUCCESS = 'FILTER_GET_SUCCESS';
export const FILTER_CREATE_SUCCESS = 'FILTER_CREATE_SUCCESS';
export const FILTER_UPDATE_SUCCESS = 'FILTER_UPDATE_SUCCESS';
export const FILTER_DELETE_SUCCESS = 'FILTER_DELETE_SUCCESS';
export const FILTER_EXECUTE_SUCCESS = 'FILTER_EXECUTE_SUCCESS';
export const FORMULA_SIMULATE_SUCCESS = 'FORMULA_SIMULATE_SUCCESS';
export const FILTER_BY_ID_SUCCESS = 'FILTER_BY_ID_SUCCESS';
export const FILTER_BY_NAME_SUCCESS = 'FILTER_BY_NAME_SUCCESS';
export const FILTER_BY_GROUP_SOURCE_SUCCESS = 'FILTER_BY_GROUP_SOURCE_SUCCESS';

/* QUERIES */
export const QUERY_LIST_SUCCESS = 'QUERY_LIST_SUCCESS';
export const QUERY_BY_ID_SUCCESS = 'QUERY_BY_ID_SUCCESS';
export const QUERY_CREATE_SUCCESS = 'QUERY_CREATE_SUCCESS';
export const QUERY_UPDATE_SUCCESS = 'QUERY_UPDATE_SUCCESS';
export const QUERY_DELETE_SUCCESS = 'QUERY_DELETE_SUCCESS';
export const QUERY_TEST_SUCCESS = 'QUERY_TEST_SUCCESS';
export const QUERY_FUNCTIONS_SUCCESS = 'QUERY_FUNCTIONS_SUCCESS';

/* GLOBAL LIST */
export const GLOBAL_LIST_METADATA_SUCCESS = 'GLOBAL_LIST_METADATA_SUCCESS';
export const GLOBAL_LIST_DATA_SUCCESS = 'GLOBAL_LIST_DATA_SUCCESS';

/* LOGS */
export const LOG_LIST_SUCCESS = 'LOG_LIST_SUCCESS';
export const LOG_GET_SUCCESS = 'LOG_GET_SUCCESS';
export const LOG_OPERATIONS_SUCCESS = 'LOG_OPERATIONS_SUCCESS';
export const LOG_STATS_SUCCESS = 'LOG_STATS_SUCCESS';